import React from "react";
import ReportPage from "./ReportPage";

export default function EmployeeReports() {
  return (
    <ReportPage
      title="Employee Reports"
      subtitle="Employee report and staff status listing."
      endpoint="/reports/employee"
      exportName="employee"
      requiresRun={false}
      summaryCards={[
        { key: "total_staff", label: "Total Staff" },
        { key: "active_staff", label: "Active Staff" },
        { key: "inactive_staff", label: "Inactive Staff" },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "status", label: "Status" },
        { key: "faculty", label: "Faculty" },
        { key: "finance_office", label: "Finance Office" },
        { key: "rank", label: "Rank" },
        { key: "appointment_status", label: "Appointment Status" },
      ]}
    />
  );
}
